/**
 * @desc getDetailByIono
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  number: string | number,
  params: API.wms.inMaster.getDetailByIono.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/inMaster/receiving/${number}`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
